import { render } from "./templateManage.vue?vue&type=template&id=72d45ae8&ts=true"
import script from "./templateManage.vue?vue&type=script&lang=ts"
export * from "./templateManage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__